import React, { useState } from 'react';
import css from './UnlockableContent.module.css';
import { FormattedMessage } from 'react-intl';
import { SingleDatePicker } from 'react-dates';
import moment from 'moment';
import { Field } from 'react-final-form';

const ContentExpireSection = ({ fieldName }) => {
  const [focused, setFocused] = useState(false);

  return (
    <div className={css.itemFld}>
      <label htmlFor={`${fieldName}.expirationDate`} className={css.datePickerLabel}>
        <FormattedMessage
          id="ContentExpireSection.expireContentDateLabel"
          defaultMessage="Content Expiration Date"
        />
      </label>
      <Field name={`${fieldName}.expirationDate`}>
        {({ input, meta }) => {
          // Convert Unix timestamp back to moment for display
          const dateValue = input.value ? moment.unix(input.value) : null;

          return (
            <div>
              <SingleDatePicker
                date={dateValue}
                onDateChange={date => {
                  // Convert selected date to Unix timestamp (in seconds)
                  const unixTimestamp = date ? date.unix() : null;
                  input.onChange(unixTimestamp);
                }}
                focused={focused}
                onFocusChange={({ focused }) => setFocused(focused)}
                id={`${fieldName}_expiration_date`}
                numberOfMonths={1}
                isOutsideRange={date => date.isBefore(moment().startOf('day'))}
                displayFormat="MMM D, YYYY"
                placeholder="Select a date"
                hideKeyboardShortcutsPanel
                small
                block
              />
              {meta.error && meta.touched && (
                <div className={css.error} role="alert">
                  {meta.error}
                </div>
              )}
            </div>
          );
        }}
      </Field>
    </div>
  );
};

export default ContentExpireSection;
